module.exports = __webpack_public_path__ + "img/next.e9dc505d.svg";